module.exports = __webpack_public_path__ + "static/img/ent-detail-1.421e3f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-1.jpg
// module id = SIHN
// module chunks = 52